// icons
import { CiMoneyBill } from 'react-icons/ci';
import { FiAward } from 'react-icons/fi';
import { GiRank3 } from 'react-icons/gi';
import { GoClock } from 'react-icons/go';
import { GrDocumentVerified, GrLineChart } from 'react-icons/gr';
import { HiOutlineDocumentCheck } from 'react-icons/hi2';
import { RiComputerLine } from 'react-icons/ri';
import { SlEnvolopeLetter } from 'react-icons/sl';
import { TbHeartHandshake, TbSchool, TbPigMoney } from 'react-icons/tb';
import { TiArrowShuffle } from 'react-icons/ti';
import { VscArrowSwap } from 'react-icons/vsc';

export default {
  afforda: {
    icon: <TbPigMoney size={18} />,
    description: 'Connect with a school advisor to discuss scholarship and financial aid opportunities.',
  },
  salary: {
    icon: <CiMoneyBill size={18} />,
    description: 'This program has the potential to transform your career and open doors to a higher salary.',
  },
  transcript: {
    icon: <HiOutlineDocumentCheck size={18} />,
    description: 'This school aims to make your transcript submission as simple as possible.',
  },
  'transfer credits': {
    icon: <VscArrowSwap style={{ transform: 'rotate(135deg)' }} size={18} />,
    description: 'Chat with an advisor to learn how you can easily transfer your previous credits.',
  },
  flexi: {
    icon: <TiArrowShuffle style={{ transform: 'rotate(270deg)' }} size={18} />,
    description: 'This school offers a flexible classes that work with your busy schedule.',
  },
  accredit: {
    icon: <FiAward size={18} />,
    description:
      'Accreditors ensure you receive a quality education. This school has met its accreditation credentials.',
  },
  length: {
    icon: <GoClock size={18} />,
    description: 'You could graduate in as little as 4 years! Let this school know you’re interested.',
  },
  online: {
    icon: <RiComputerLine size={18} />,
    description: '',
  },
  roi: {
    icon: <GrLineChart size={18} stroke="currentColor" />,
    description: '',
  },
  admission: {
    icon: <SlEnvolopeLetter size={18} />,
    description: 'This school has a high admissions rate. Start your application today!',
  },
  military: {
    icon: <GiRank3 size={18} />,
    description:
      'Veterans who qualify for the Post-9/11 G.I. Bill may have the full cost of their tuition and fees covered.',
  },
  diversity: {
    icon: <TbHeartHandshake size={18} />,
    description: 'Ask an advisor about class sizes, demographics, student groups, and more.',
  },
  default: {
    icon: <TbSchool size={18} />,
    description: '',
  },
};
